<script lang="ts">
  import type { Snippet } from 'svelte';
  import { _ } from 'svelte-i18n';
  import { page } from '$app/state';
  import { goto } from '$app/navigation';
  import { isWmsAppRouteAllowed } from '$lib/wms/app/wms-app';
  import { isFullHeightWmsPath } from '$lib/wms/workspace-layout';
  import { auth } from '$lib/stores/auth';
  import { Button } from '$lib/components/ui/button/index.js';
  import * as DropdownMenu from '$lib/components/ui/dropdown-menu/index.js';
  import Menu from '@lucide/svelte/icons/menu';
  import House from '@lucide/svelte/icons/house';
  import { wmsAccess } from '$lib/stores/wmsAccess';
  import { getWmsShortcuts } from '$lib/wms/app/wms-navigation';
  import { WMS_APP_START_PATH } from '$lib/wms/app/wms-app';
  import AppVersionDetails from '$lib/components/layout/AppVersionDetails.svelte';
  import HeaderPreferencesMenu from '$lib/components/HeaderPreferencesMenu.svelte';
  import WmsAppActions from './WmsAppActions.svelte';
  let { children }: { children: Snippet } = $props();
  const fullHeight = $derived(isFullHeightWmsPath(page.url.pathname));
  const shortcuts = $derived(getWmsShortcuts($wmsAccess, (key) => $_(key)));
  async function logout() {
    if (window.confirm($_('menu.logoutConfirm'))) await auth.logout();
  }
</script>

<div class="flex min-h-0 flex-1 flex-col overflow-hidden bg-background">
  <header class="flex shrink-0 items-center justify-between gap-2 border-b border-border px-3 py-2">
    <div class="flex min-w-0 items-center gap-2">
      <a href={WMS_APP_START_PATH} aria-label={$_('vms.app.home')} class="flex min-h-11 items-center gap-2 rounded-md text-sm font-semibold focus-visible:outline-2 focus-visible:outline-ring">
        <House class="size-5" aria-hidden="true" />
        <span>{$_('vms.app.name')}</span>
      </a>
      <AppVersionDetails />
    </div>
    <div class="flex items-center gap-2">
      <WmsAppActions />
      <DropdownMenu.Root>
        <DropdownMenu.Trigger>
          {#snippet child({ props })}
            <Button {...props} size="icon" variant="ghost" aria-label={$_('menu.navigation')}>
              <Menu class="size-5" aria-hidden="true" />
            </Button>
          {/snippet}
        </DropdownMenu.Trigger>
        <DropdownMenu.Content align="end">
          <DropdownMenu.Item onSelect={() => void goto(WMS_APP_START_PATH)}>{$_('vms.app.home')}</DropdownMenu.Item>
          <DropdownMenu.Separator />
          {#each shortcuts as shortcut (shortcut.key)}
            <DropdownMenu.Item onSelect={() => void goto(shortcut.href)}>{shortcut.title}</DropdownMenu.Item>
          {/each}
          <DropdownMenu.Separator />
          <DropdownMenu.Item onclick={logout}>{$_('menu.logout')}</DropdownMenu.Item>
        </DropdownMenu.Content>
      </DropdownMenu.Root>
      <HeaderPreferencesMenu />
    </div>
  </header>
  <main data-route-scroll-host="true" class={`min-h-0 flex-1 ${fullHeight ? 'overflow-hidden sm:overflow-auto' : 'overflow-auto'}`}>
    <div class={fullHeight ? 'h-full min-h-0' : 'p-3 sm:p-6'}>
      {#if isWmsAppRouteAllowed(page.url.pathname)}{@render children()}{/if}
    </div>
  </main>
</div>
